/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 * @interface ComIbmCommercePromotionFacadeDatatypesPromotionScheduleType
 */
export interface ComIbmCommercePromotionFacadeDatatypesPromotionScheduleType {
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommercePromotionFacadeDatatypesPromotionScheduleType
     */
    dailyStartTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommercePromotionFacadeDatatypesPromotionScheduleType
     */
    dailyEndTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommercePromotionFacadeDatatypesPromotionScheduleType
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommercePromotionFacadeDatatypesPromotionScheduleType
     */
    weekDays?: ComIbmCommercePromotionFacadeDatatypesPromotionScheduleTypeWeekDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof ComIbmCommercePromotionFacadeDatatypesPromotionScheduleType
     */
    startDate?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ComIbmCommercePromotionFacadeDatatypesPromotionScheduleTypeWeekDaysEnum {
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday'
}



